import icon from "@material-ui/icons/AccountBox"
export { default as CustomerRepsList } from "./customerReps/list";
export { default as CustomerRepsCreate } from "./customerReps/create";
export { default as CustomerList } from "./list";
export { default as CustomerCreate } from "./create";
export { default as CustomerEdit } from "./edit";
export { default as CustomerRegionList } from "./customerRegions/list";
export { default as CustomerRegionCreate } from "./customerRegions/create";

export default { icon } ;